import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import Alpine from 'alpinejs'

function getGclidFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('gclid');
}

function storeGclid() {
    const gclid = getGclidFromUrl();
    if (gclid) {
        sessionStorage.setItem('gclid', gclid);
        localStorage.setItem('gclid', gclid);
    }
}

function populateGclidFields() {
    const gclid = sessionStorage.getItem('gclid') || localStorage.getItem('gclid');
    if (gclid) {
        const gclidInputs = document.querySelectorAll('input[name="gclid"]');
        gclidInputs.forEach(input => {
            input.value = gclid;
        });
    }
}

// Function to adjust the height of a textarea
function adjustHeight(textarea) {
    // Reset height temporarily to get the correct scrollHeight
    textarea.style.height = 'auto';
    // Set the height to match the content
    textarea.style.height = textarea.scrollHeight + 'px';
}

// Function to reset a textarea
function resetTextarea(textarea) {
    textarea.value = '';
    textarea.style.height = '80px'; // Reset to minimum height
}

document.addEventListener('DOMContentLoaded', function () {
    // Store GCLID if present in URL
    storeGclid();
    
    // Populate GCLID fields if they exist
    populateGclidFields();

    var swiper = new Swiper(".home-slider", {
        effect: "fade",
        modules: [Pagination, Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });

    var swiper = new Swiper(".hero-gallery-slider", {
        effect: "fade",
        modules: [Pagination, Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: false,
            clickable: true,
        },
    });


    window.Alpine = Alpine;
    Alpine.start();


    // Get all textareas with data-autoresize attribute
    const textareas = document.querySelectorAll('textarea[data-autoresize]');

    textareas.forEach(textarea => {
        // Set initial height
        adjustHeight(textarea);

        // Add input event listener
        textarea.addEventListener('input', function() {
            adjustHeight(this);
        });
    });
    
});

